<template>
  <b-form @submit.prevent>
    <b-form-row>
      <b-form-group label="Wyrażenie" class="mr-3">
        <b-form-input v-model="filters.term" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Tłumaczenie" class="mr-3">
        <b-form-input v-model="filters.translation" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Część mowy" class="mr-3">
        <b-form-select v-model="filters.partOfSpeech" :options="partOfSpeechOptions"></b-form-select>
      </b-form-group>

      <b-form-group class="mt-auto">
        <b-button type="submit" class="mr-3" variant="primary" @click="onSearch">Szukaj</b-button>
        <b-button type="submit" class="mr-3" variant="secondary" @click="clear">Wyczyść</b-button>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      filters: {
        term: null,
        translation: null,
        partOfSpeech: null
      },
      partOfSpeechOptions: [
        { value: null, text: "" },
        { value: 1, text: "czasownik regularny" },
        { value: 2, text: "czasownik nieregularny" },
        { value: 6, text: "czasownik frazalny" },
        { value: 7, text: "idiom" },
        { value: 3, text: "przymiotnik" },
        { value: 4, text: "przysłówek" },
        { value: 0, text: "rzeczownik" },
        { value: 8, text: "wyrażenie" },
        { value: 5, text: "zaimek" }
      ]
    };
  },
  methods: {
    clear() {
      this.filters.term = null;
      this.filters.translation = null;
      this.filters.partOfSpeech = null;
    },
    onSearch() {
      this.$emit("filters-search", this.filters);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>